import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bd183fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 20px"}
}

import { reactive, ref, PropType, computed, watch, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType, TABLE_PREVIEW_PAGE_SIZE, TABLE_FULL_PAGE_SIZE_DEFAULT } from '@/views/dashboard/_enum/table-view-mode'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import TerminalDetailList from './terminal-detail-list.vue'
import { FormType, DateType } from '@/components/cmForm/types'
import { PopupItem, PopupQueryParams, PopupViewService, PopupSoftwareListEmbedDefaults } from './popup-view/popup-view.service'
import { ElMessage } from 'element-plus'
import { useParseTime } from '@/hooks'

type PopupSoftwareQueryParams = PopupQueryParams & {
  dateRange?: [string, string]
}

const DefaultPopType = 4

export default /*#__PURE__*/_defineComponent({
  __name: 'popup-software-list',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  hasPermission: {
    type: Boolean,
    default: false
  },
  /** 全量抽屉：由排行等带入的默认关键词与时间（重置时回到该基准） */
  embedDefaults: {
    type: Object as PropType<PopupSoftwareListEmbedDefaults | null>,
    default: null
  }
},
  emits: ["selectionChange", "viewAll", "trustSuccess"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const popupTypeDict = computed(() => ['', t('popupIntercept.filterBottomRightBubble'), t('popupIntercept.filterCenterBubble'), t('popupIntercept.filterBundledSoft')])
const popupTypes = computed(() => [
  { label: t('popupIntercept.filterAll'), value: 4 },
  { label: t('popupIntercept.filterBottomRightBubble'), value: 1 },
  { label: t('popupIntercept.filterCenterBubble'), value: 2 },
  { label: t('popupIntercept.filterBundledSoft'), value: 3 }
])

const props = __props

const emits = __emit

const injector = useReflectiveInjector([PopupViewService])
const popupViewService = injector.get(PopupViewService)
const dataApi = popupViewService.fetchPopUpList.bind(popupViewService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const selectedIds = ref<string[]>([])
const selectedRows = ref<PopupItem[]>([])
const terminalDrawerVisible = ref(false)
const currentPopupSoftware = ref<PopupItem | null>(null)

const embed = () => props.embedDefaults

const queryParams = reactive<PopupSoftwareQueryParams>({
  key_word: embed()?.key_word ?? '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? TABLE_PREVIEW_PAGE_SIZE : TABLE_FULL_PAGE_SIZE_DEFAULT,
  sort: '',
  asc: false,
  popup_type: embed()?.popup_type ?? DefaultPopType,
  dateRange: props.viewMode === TableViewMode.full ? embed()?.dateRange : undefined,
  start_time: props.viewMode === TableViewMode.full ? embed()?.start_time : undefined,
  end_time: props.viewMode === TableViewMode.full ? embed()?.end_time : undefined
})

const popupTypeLabel = computed(() => popupTypeDict.value[currentPopupSoftware.value?.popup_type || 0] || t('popupIntercept.unknownPopup'))

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
  bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
  columns: [
    { prop: 'soft_name', label: t('popupIntercept.softName'), columnOpt: { minWidth: 150 } },
    {
      prop: 'popup_type',
      label: t('popupIntercept.popupType'),
      formatter: (_row, val) => popupTypeDict.value[val] || '--',
      columnOpt: { minWidth: 120 }
    },
    { prop: 'intercept_count', label: t('popupIntercept.interceptCount'), sortable: 'custom', columnOpt: { minWidth: 100 } },
    { prop: 'popup_count', label: t('popupIntercept.popupCount'), sortable: 'custom', columnOpt: { minWidth: 100 } },
    {
      prop: 'latest_popup_time',
      label: t('popupIntercept.recentInterceptTime'),
      sortable: 'custom',
      formatter: (_row, val) => val ? new Date(val * 1000).toLocaleString() : '--',
      columnOpt: { minWidth: 160 }
    },
    { prop: 'terminal_count', label: t('popupIntercept.involvedTerminalCount'), columnOpt: { minWidth: 120 } }
  ],
  rowKey: 'soft_id',
  selection: true,
  path: 'list',
  height: props.viewMode === TableViewMode.preview ? undefined : '100%',
  hiddenPageTool: props.viewMode === TableViewMode.preview,
  disableScrollLoad: props.viewMode === TableViewMode.preview
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
  isLink: false,
  height: '100%',
  columnOpt: { label: t('popupIntercept.operation'), width: 120, align: 'left' },
  actionButtons: () => []
  }
})

const filterFormColumns = computed(() => {
  void locale.value
  const popupTypeCol = {
    prop: 'popup_type',
    label: t('popupIntercept.popupType'),
    colOpt: { style: 'flex: 0 0 150px' },
    hiddenAllLabel: true,
    outSearchFiledFlag: true,
    selectOpt: { clearable: true },
    type: FormType.Select,
    dictData: popupTypes.value,
    events: { change: handleQuery }
  }
  if (props.viewMode !== TableViewMode.full) {
    return [popupTypeCol]
  }
  const dateRangeCol = {
    prop: 'dateRange',
    label: t('popupIntercept.filterInterceptTimeRange'),
    colOpt: { style: 'flex:0 0 260px' },
    type: FormType.Date,
    dateType: DateType.DateRange,
    events: {
      change: (val: string[] | undefined) => {
        if (val?.length === 2 && val[0] && val[1]) {
          const [start, end] = useParseTime(val)
          queryParams.start_time = start != null ? String(start) : undefined
          queryParams.end_time = end != null ? String(end) : undefined
        } else {
          queryParams.start_time = undefined
          queryParams.end_time = undefined
        }
        queryParams.page = 1
        void refreshList()
      }
    },
    dateOpt: {
      'value-format': 'YYYY-MM-DD',
      'start-placeholder': t('remoteAuth.startPlaceholder'),
      'end-placeholder': t('remoteAuth.endPlaceholder'),
      clearable: true
    }
  }
  return [dateRangeCol, popupTypeCol]
})

function handleSelectionChange(selection: PopupItem[], ids: string[]) {
  selectedRows.value = selection ?? []
  selectedIds.value = ids ?? []
  emits('selectionChange', ids)
}

function handleSearch(val) {
  queryParams.key_word = val
  queryParams.page = 1
  void refreshList()
}

async function handleQuery() {
  queryParams.page = 1
  await refreshList()
}

function applyEmbedToQuery(d: PopupSoftwareListEmbedDefaults | null) {
  if (props.viewMode !== TableViewMode.full) return
  if (d) {
    queryParams.key_word = d.key_word ?? ''
    queryParams.popup_type = d.popup_type ?? DefaultPopType
    if (d.dateRange?.length === 2 && d.start_time != null && d.end_time != null) {
      queryParams.dateRange = [d.dateRange[0], d.dateRange[1]]
      queryParams.start_time = d.start_time
      queryParams.end_time = d.end_time
    } else {
      queryParams.dateRange = undefined
      queryParams.start_time = undefined
      queryParams.end_time = undefined
    }
    return
  }
  queryParams.key_word = ''
  queryParams.popup_type = DefaultPopType
  queryParams.dateRange = undefined
  queryParams.start_time = undefined
  queryParams.end_time = undefined
}

watch(
  () => props.embedDefaults,
  (d) => {
    if (props.viewMode !== TableViewMode.full) return
    applyEmbedToQuery(d ?? null)
    nextTick(() => void refreshList())
  },
  { deep: true },
)

function handleReset() {
  queryParams.page = 1
  if (props.viewMode === TableViewMode.full && props.embedDefaults) {
    applyEmbedToQuery(props.embedDefaults)
  } else {
    applyEmbedToQuery(null)
  }
  void refreshList()
}

function openTerminalDrawer(row: PopupItem) {
  currentPopupSoftware.value = row
  terminalDrawerVisible.value = true
}

async function handleTrustPopup() {
  if (!selectedRows.value.length) return
  const popup_list = selectedRows.value.map((item) => ({
    soft_id: item.soft_id,
    popup_type: item.popup_type
  }))
  try {
    await popupViewService.trustOrder({ popup_list, is_trust: true })
    ElMessage.success(
      popup_list.length > 1
        ? t('popupIntercept.trustManySuccess', { count: popup_list.length })
        : t('popupIntercept.trustOneSuccess', { name: selectedRows.value[0].soft_name || '' })
    )
    tableRef.value?.tableRef?.clearSelection?.()
    selectedRows.value = []
    selectedIds.value = []
    emits('trustSuccess')
    void refreshList()
  } catch {
    ElMessage.error(t('popupIntercept.trustFailed', { count: popup_list.length }))
  }
}

__expose({
  tableRef,
  selectedIds
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      tableOpt: tableOpt.value,
      tableActOpt: tableActOpt.value,
      firstLoading: true,
      "has-permission": __props.hasPermission,
      api: _unref(dataApi),
      modelValue: queryParams,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
      pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
      onChangeSelected: handleSelectionChange
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: queryParams,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !__props.hasPermission,
          "show-search": true,
          "sync-search-from-field": "key_word",
          "search-placeholder": _ctx.$t('popupIntercept.searchPlaceholderSoft'),
          "popover-threshold": 2,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              disabled: !selectedRows.value.length || !__props.hasPermission,
              onClick: handleTrustPopup
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('popupIntercept.trustPopup')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (__props.viewMode === _unref(TableViewMode).preview)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "",
                  plain: "",
                  disabled: !__props.hasPermission,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('viewAll')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      terminal_count: _withCtx(({ row }: any) => [
        (row?.terminal_count)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: ($event: any) => (openTerminalDrawer(row as PopupItem)),
              type: "text",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.terminal_count), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, "0"))
      ]),
      _: 1
    }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "70%",
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      direction: "rtl",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('popupIntercept.terminalListTitleWithType', { soft: currentPopupSoftware.value?.soft_name || '', type: popupTypeLabel.value })), 1),
        _createVNode(TerminalDetailList, {
          "soft-id": currentPopupSoftware.value?.soft_id,
          "popup-type": currentPopupSoftware.value?.popup_type
        }, null, 8, ["soft-id", "popup-type"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})